export const BOARD_BASIS_LABELS: Record<string, string> = {
  RO: "Solo camera",
  BB: "Bed & Breakfast",
  HB: "Mezza pensione",
  FB: "Pensione completa",
  AI: "All inclusive",
};

export const BOOKING_STATUS_LABELS: Record<string, string> = {
  confirmed: "Confermata",
  pending_confirmation: "In attesa",
  partially_confirmed: "Parzialmente confermata",
  failed: "Fallita",
  cancelled: "Annullata",
};

export const BOOKING_STATUS_TONE: Record<
  string,
  "success" | "warning" | "error" | "muted"
> = {
  confirmed: "success",
  pending_confirmation: "warning",
  partially_confirmed: "warning",
  cancellation_requested: "warning",
  failed: "error",
  // Cancelled bookings: tonal error (not silent muted) so users spot them
  // at a glance when scanning the list.
  cancelled: "error",
};

export const AGENCY_TYPES = [
  { value: "traditional", label: "Tradizionale" },
  { value: "business", label: "Business" },
  { value: "luxury", label: "Luxury" },
  { value: "leisure", label: "Leisure" },
  { value: "mixed", label: "Mista" },
] as const;

export const COUNTRIES = [
  { value: "IT", label: "Italia" },
  { value: "FR", label: "Francia" },
  { value: "DE", label: "Germania" },
  { value: "ES", label: "Spagna" },
  { value: "GB", label: "Regno Unito" },
] as const;

export const CURRENCIES = ["EUR", "GBP", "CHF", "USD"] as const;

/**
 * Valori accettati dal BE booking-engine nell'header `X-Active-Role`.
 * Allineati all'enum ORG_TYPE del Controlplane: il BE inoltra la stringa as-is
 * a `/memberships/user/.../org-by-type?org_type=...`.
 */
export const ACTIVE_ROLES = ["OTA", "TRAVEL_AGENCY", "DMC", "BAD_BANK"] as const;
export type ActiveRole = (typeof ACTIVE_ROLES)[number];

export const ACTIVE_ROLE_LABELS: Record<ActiveRole, string> = {
  OTA: "OTA",
  TRAVEL_AGENCY: "Travel Agency",
  DMC: "DMC",
  BAD_BANK: "Bad Bank",
};

export const STAR_OPTIONS = [1, 2, 3, 4, 5] as const;

export const RESULTS_PAGE_SIZE = 30;
export const RECENT_SEARCHES_LIMIT = 10;
